export default __webpack_public_path__ + "media/images/logo-btp-68abbafe64bf3362f3ce1b7d2a1e49cd.svg";